import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '@security/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard  {
  constructor(private auth: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.auth.isAuthenticated) {
      this.auth.navigation.navigateToSecure();
      return false;
    }
    return true;
  }

}
